var map = {
	"./adult/nn/1 0 Orddiktat Intro.mp3": 551,
	"./adult/no/1 0 Orddiktat Intro.mp3": 552,
	"./youth/de/1 0 Orddiktat Intro.mp3": 553,
	"./youth/nn/1 0 Orddiktat Intro.mp3": 554,
	"./youth/no/1 0 Orddiktat Intro.mp3": 555,
	"./youth/se/1 0 Orddiktat Intro.mp3": 556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 550;